
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { useId, useMemo } from "react";

export default function BrandSlider({ brands = [], top = 10, left = 0, reverse = false }) {
    const uid = useId().replace(/:/g, "");
    const swiperClass = `about-brands-swiper-${uid}`;

    const duplicatedBrands = useMemo(() => {
        if (!brands || brands.length === 0) return [];
        // Need enough slides for seamless loop on wide screens
        if (brands.length < 10) {
            return [...brands, ...brands, ...brands, ...brands];
        }
        return [...brands, ...brands, ...brands];
    }, [brands]);

    if (!brands || brands.length === 0) {
        return <div style={{ height: "58px", marginTop: `${top}px` }} />;
    }

    return (
        <div style={{ width: "100%", marginTop: `${top}px`, overflow: "hidden" }}>
            <style>{`
                .${swiperClass} .swiper-wrapper {
                    transition-timing-function: linear !important;
                }
            `}</style>
            <Swiper
                className={swiperClass}
                modules={[Autoplay, FreeMode]}
                spaceBetween={10}
                slidesPerView="auto"
                loop={true}
                loopAdditionalSlides={duplicatedBrands.length}
                speed={5000}
                style={{
                    marginLeft: `-${left}px`,
                }}
                allowTouchMove={false}
                freeMode={{
                    enabled: true,
                    momentum: false,
                }}
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    reverseDirection: reverse,
                }}
                observer={true}
                observeParents={true}
            >
                {duplicatedBrands.map((brand, index) => (
                    <SwiperSlide
                        key={`${brand.id || brand.name || "brand"}-${index}`}
                        style={{
                            width: "auto",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                border: "1px solid #EEEEEE",
                                borderRadius: "30px",
                                padding: "12px 30px",
                            }}
                        >
                            <img
                                src={process.env.REACT_APP_STORAGE_URL + brand.logo}
                                alt={brand.name || "brand"}
                                style={{ maxHeight: "35px", maxWidth: "80%" }}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
